var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"econ"},[_c('breadcrumb',{attrs:{"icon":"el-icon-s-grid"}}),_c('div',{staticClass:"tabbox"},[_c('econ-nav',{attrs:{"cate":"layout"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }